import './Tree.scss';

export { default } from './ComponentTree';
